import {Col, Form, Row} from "react-bootstrap";
import {ModalDialog} from "../modal/ModalDialog.js";
import React from "react";
import {APIClient} from "../../core/utils/APIClient.js";
import useForm from "../../core/hooks/useForm.js";
import {fetchPromises} from "../../core/utils/fetchPromises.js";

function RetailerModal({setModal, retailer, refreshRetailers, countries}) {
    const {form, onInputChange} = useForm({
        countryId: countries && countries[0].id,
        ...retailer
    });

    const onModalSaveClick = async () => {
        try {

            await APIClient().saveRetailer({
                ...form
            });
            refreshRetailers();
        } catch (e) {
            console.log(e);
        }
    }

    const onModalClose = () => {
        setModal({
            show: false
        });
    }

    return (
        <ModalDialog show onClose={onModalClose} onCallback={onModalSaveClick} title="Retailer">
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Name
                </Form.Label>
                <Col sm="8">
                    <Form.Control type="text" name="name" onChange={onInputChange} value={form.name || ''} required />
                    <Form.Control.Feedback type="invalid">
                        Field is required.
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="4">
                    Country
                </Form.Label>
                <Col sm="8">
                    <Form.Select name="countryId" onChange={onInputChange} value={form.countryId}>
                        {countries && countries.map((c, index) =>
                            <option key={index} value={c.id}>{c.name}</option>
                        )}
                    </Form.Select>
                </Col>
            </Form.Group>
        </ModalDialog>
    );
}

export default fetchPromises({
    retailer: (props) => props.retailerId && ({ name: 'getRetailer', props: ['retailerId'] }),
    countries: () => ({ name: 'getCountries' })
}, false)(RetailerModal);
